import gql from 'graphql-tag';
import { ORDER_FRAGMENT } from '../fragments';

/**
 * 获取订单列表
 */
export const fetchOrderListDocument = gql`
  query orders($options: OrderListOptions) {
    orders(options: $options) {
      items {
        id
        code
        state
        total
        isPaymentRewardActivity
        fulfillments {
          method
        }
        customFields {
          buyType
          subscription {
            id
            expireNumberOfPeriod
          }
          periods
          deliveryInterval
          timeoutPeriodToBePaid
          orderPromotionResult {
            promResult {
              orderTotalPrice
              orderTotalPoints
            }
          }
        }
        lines {
          id
          quantity
          totalQuantity
          unitPrice
          featuredAsset {
            preview
          }
          customFields {
            afterSaleLine {
              id
            }
          }
          productVariant {
            id
            sku
            price
            name
            options {
              code
              name
            }
            featuredAsset {
              source
            }
            customFields {
              virtualTargetType
            }
            product {
              id
              name
              enabled
              customFields {
                isVipProduct
              }
              featuredAsset {
                source
              }
              customFields {
                price
                markingPrice
                unit
              }
            }
          }
        }
      }
      totalItems
    }
  }
`;

/**
 * 获取订单详情
 */
export const fetchOrderDetailsDocument = gql`
  query order($id: ID!) {
    order(id: $id) {
      id
      orderPlacedAt
      code
      state
      isPaymentRewardActivity
      orderBuyUserCouponId
      customFields {
        subscription {
          id
          expireNumberOfPeriod
        }
        buyType
        periods
        deliveryInterval
        isAvailableAfterSale
        timeoutPeriodToBePaid
        timeoutPeriodToBeReceived
        remark
        orderPromotionResult {
          promResult {
            orderTotalPrice
            orderTotalPoints
          }
        }
      }
      fulfillments {
        id
        createdAt
        method
      }
      lines {
        id
        quantity
        totalQuantity
        unitPrice
        featuredAsset {
          source
        }
        blindBoxRefundableAmount
        merchantVoluntaryRefund
        productVariant {
          id
          sku
          price
          name
          options {
            code
            name
          }
          featuredAsset {
            source
          }
          customFields {
            virtualTargetType
          }
          product {
            id
            name
            enabled
            customFields {
              isVipProduct
            }
            featuredAsset {
              source
            }
            customFields {
              price
              markingPrice
            }
          }
        }
        customFields {
          purchasePattern
          isAvailableAfterSale
          afterSaleLine {
            id
            createdAt
            updatedAt
            quantity
            price
          }
          afterSale {
            id
            cause
            state
            mode
          }
        }
      }
      surcharges {
        price
      }
      shipping
      shippingAddress {
        fullName
        company
        streetLine1
        streetLine2
        city
        province
        postalCode
        country
        countryCode
        phoneNumber
        customFields {
          district
        }
      }
    }
  }
`;

/**
 * 根据商户交易id获取订单信息
 */
export const fetchOrderInfoByPaymentCodeDocument = gql`
  query getOrderTypeByPaymentCode($paymentCode: String!) {
    getOrderTypeByPaymentCode(paymentCode: $paymentCode) {
      orderType
      orderId
    }
  }
`;

/**
 * 删除订单
 */
export const fetchDeleteOrderDocument = gql`
  mutation deleteOrder($orderId: ID!) {
    deleteOrder(orderId: $orderId) {
      result
      message
    }
  }
`;

/**
 * 修改发货地址
 */
export const fetchUpdateOrderShippingAddressDocument = gql`
  mutation updateOrderShippingAddress($orderId: ID!, $input: CreateAddressInput!) {
    updateOrderShippingAddress(orderId: $orderId, input: $input) {
      ...Order
    }
  }
  ${ORDER_FRAGMENT}
`;

/**
 * 确认收货
 */
export const fetchConfirmReceiptOfGoodsDocument = gql`
  mutation confirmReceiptOfGoods($orderId: ID!) {
    confirmReceiptOfGoods(orderId: $orderId) {
      ...Order
    }
  }
  ${ORDER_FRAGMENT}
`;

/**
 * 取消订单
 */
export const fetchCancelledOrderDocument = gql`
  mutation cancelledOrder($orderId: ID!) {
    cancelledOrder(orderId: $orderId) {
      ...Order
    }
  }
  ${ORDER_FRAGMENT}
`;

/**
 * 查询订单栏各待办数量
 */
export const fetchPendingOrdersNumberDocument = gql`
  query pendingOrdersNumber {
    pendingOrdersNumber {
      toBePaidNumber
      toBeShippedNumber
      toBeReceivedNumber
      toBeEvaluatedNumber
      toBeAfterSalesNumber
    }
  }
`;

/**
 * 获取商家主动退款信息
 */
export const fetchMerchantVoluntaryRefundByOrderDocument = gql`
  query merchantVoluntaryRefundByOrder($orderId: ID!) {
    merchantVoluntaryRefundByOrder(orderId: $orderId) {
      id
      createdAt
      updatedAt
      price
      reason
    }
  }
`;
